<template>
    <el-dialog @opened="cshData" :visible.sync="rsvrCz.openShow" :show-close="false" :close-on-click-modal="false" top="110px">
        <div style="box-sizing: border-box;padding: 20px;height: 100%;">
            <div style="background-color: #f7f7f7;height: 100%;">
                <div style="display: flex;align-items: center;">
                    <img src="@/assets/icons/monitor/station.svg" style="height: 30px;width: 30px;margin-left: 30px;margin-right: 10px;">
                    <!-- <div style="color: #53abfd;font-size: 18px;font-weight: 700;">
                        {{ rsvrCz.cz.stnm }}
                    </div> -->
                    <div>
                        <el-select v-model="rsvrCz.cz.stcd" placeholder="请选择" size="small" @change="jygcData">
                            <el-option
                                v-for="item in czOptions"
                                :key="item.stcd"
                                :label="item.stnm"
                                :value="item.stcd"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <tab-switch :buttonNamesArr="buttonNamesArr" :delImg="rsvrCz.openShow" @delImgDeal="delImgDeal" @curTabButtonClickDeal="curTabButtonClickDeal" style="background-color: #f7f7f7;">
                    </tab-switch>
                </div>
                <div v-show="activeName == 0">
                    <div style="margin: 10px 0;width: 100%;">
                        <!-- <span style="margin: 0 30px;color: #323232;font-size: 18px;font-weight: 700;">{{ rsvrCz.cz.stnm }}</span> -->
                        <span style="font-size: 14px;margin-right: 10px;margin-left: 30px;">时段</span>
                        <el-select v-model="orForm.hour" placeholder="请选择" size="small" style="width: 120px;" @change="sjdChange">
                            <el-option
                                v-for="item in sjdOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <span style="font-size: 14px;margin-right: 10px;margin-left: 30px">时间</span>
                        <span v-if="orForm.hour == 0">
                            <el-date-picker
                                v-model="rsvrCz.sjfw"
                                :clearable=false
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                popper-class='myDatePicker'
                                type="datetimerange"
                                range-separator="到"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                @change="sjChange"
                            >
                            </el-date-picker>
                        </span>
                        <span v-else>
                            <el-date-picker
                                v-model="rsvrCz.sjfw"
                                :clearable=false
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                popper-class='myDatePicker'
                                type="datetimerange"
                                range-separator="到"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                @change="sjChange"
                            >
                            </el-date-picker>
                        </span>
                        <el-button type="primary" size="small" class="czBut queryButton" @click="oreset">重置</el-button>
                        <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="sjdChange(orForm.hour)">搜索</el-button>
                        <el-button type="primary" size="small" class="queryButton queryButtonPadding qDcBtn" @click="exportJygc">
                            <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                            &nbsp;导出
                        </el-button>
                    </div>
                    <el-row :gutter="20" style="padding: 0 20px;" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
                        <el-col :span="12">
                            <div v-if="orForm.hour === 0">
                                <div style="height:calc(100vh - 280px);width: 100%;background-color: #fff;padding-top: 20px;box-sizing: border-box;position: relative;">
                                    <div style="position: absolute;top: 10px;right: 60px;font-size: 22px;cursor: pointer;z-index: 100;" @click="hyhy">
                                        <i class="el-icon-refresh"></i>
                                    </div>
                                    <div id="chartZxt" class="zxtys"></div>
                                </div>
                            </div>
                            <div v-if="orForm.hour != 0" style="height:calc(100vh - 280px);width: 100%;background-color: #fff;">
                                <div style="height:50%;width: 100%;background-color: #fff;box-sizing: border-box;">
                                    <div id="jychartZxt" class="zxtys"></div>
                                </div>
                                <div style="height:50%;width: 100%;background-color: #fff;box-sizing: border-box;">
                                    <div id="chartZxt" class="zxtys"></div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div style="height:calc(100vh - 280px);width: 100%;background-color: #fff;position: relative;">
                                <div style="width:100%;height: 100%;">
                                    <el-table height="calc(100vh - 340px)" :data="otableData" border :header-cell-style="{background:'#f9f9ff',color:'#323232','text-align':'center'}" >
                                        <el-table-column v-if="orForm.hour == 0" prop="tm" label="时间" align="center"/>
                                        <el-table-column v-else prop="ht" label="时间" align="center"/>
                                        <el-table-column prop="z" label="库水位(m)" align="right">
                                            <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.z ? scope.row.z : '-' }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="w" label="蓄水量(10⁴m³)" align="right">
                                            <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.w ? scope.row.w : '-' }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="inboundFlow" label="入库流量(m³/s)" align="right">
                                            <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.inboundFlow ? scope.row.inboundFlow : '-' }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="outboundFlow" label="出库流量(m³/s)" align="right">
                                            <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.outboundFlow ? scope.row.outboundFlow : '-' }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <page-footer
                                    :rForm="orForm"
                                    @size-change="osizeChange"
                                    @current-change="ocurrentChange"
                                    style="position: absolute;bottom: 10px;right: 20px;"
                                >
                                </page-footer>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div v-show="activeName == 1">
                    <div style="margin-top: 20;">
                        <el-row :gutter="20" style="padding: 20px;box-sizing: border-box;">
                            <el-col :span="6" style="font-size: 16px;color: #777777;height:calc(100vh - 260px);box-sizing: border-box;">
                                <div style="height: 100%;width: 100%;background-color: #fff;">
                                    <div style="background-color: #f9f9ff;height: 48px;line-height: 48px;font-size: 16px;color: #323232;padding-left: 20px;font-weight: 700;">
                                        <span>测站信息</span>
                                    </div>
                                    <div style="margin: 20px;">
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                测站编码
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.stcd }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                测站名称
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.stnm }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                所属水库
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.resName }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                站类
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.sttpName }}</div>
                                        </el-col>
                                        <el-col :span="24" style="margin-bottom: 15%;">
                                            <div>
                                                站址
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.stlc }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                东经
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.lgtd }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                北纬
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ jbxx.lttd }}</div>
                                        </el-col>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6" style="font-size: 16px;color: #777777;height:calc(100vh - 260px);box-sizing: border-box;">
                                <div style="height: 100%;width: 100%;background-color: #fff;">
                                    <div style="background-color: #f9f9ff;height: 48px;line-height: 48px;font-size: 16px;color: #323232;padding-left: 20px;font-weight: 700;">
                                        <span>水库特征信息</span>
                                    </div>
                                    <div style="margin: 20px;">
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                水库名称
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx1.name }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                水库类别名称
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx1.categoryName }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                总库容(万m³)
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx2.zkr }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                死水位(m)
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx2.ssw }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                汛限水位(m)
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx2.mfsSw }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                正常蓄水位(m)
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx2.zcssw }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                设计洪水位(m)
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx2.sjhsw }}</div>
                                        </el-col>
                                        <el-col :span="12" style="margin-bottom: 15%;">
                                            <div>
                                                校核洪水位(m)
                                            </div>
                                            <div style="color: #323232;font-size: 18px;">{{ skjbxx2.jhhsw }}</div>
                                        </el-col>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12" style="box-sizing: border-box;overflow: hidden;height:calc(100vh - 260px);">
                                <el-carousel trigger="click" height="calc(100vh - 230px)">
                                    <div v-if="jbxx.imgList">
                                        <el-carousel-item v-for="item in jbxx.imgList" :key="item">
                                            <img :src="fileHost + item.path" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);width: 100%;"/>
                                        </el-carousel-item>
                                    </div>
                                    <div v-else style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
                                        <img src="@/assets/images/ysqjc/ylz.jpg" v-if="jbxx.sttp == '0801'"/>
                                        <img src="@/assets/images/ysqjc/hdsww.jpg" v-if="jbxx.sttp == '0802'"/>
                                        <img src="@/assets/images/ysqjc/sksww.jpg" v-if="jbxx.sttp == '0803'"/>
                                        <img src="@/assets/images/ysqjc/sksw.jpg" v-if="jbxx.sttp == '0804'"/>
                                        <img src="@/assets/images/ysqjc/hdsw.jpg" v-if="jbxx.sttp == '0805'"/>
                                    </div>
                                </el-carousel>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div v-show="activeName == 2">
                    <div style="margin-top: 20;" v-loading="kloading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
                        <el-row :gutter="20" style="padding: 20px;box-sizing: border-box;">
                            <el-button type="primary" size="small" @click="jsjs" style="position: absolute;top: 30px;right: 30px;z-index: 100;">库容计算</el-button>
                            <div style="height:calc(100vh - 260px);width: 100%;background-color: #fff;padding-top: 20px;box-sizing: border-box;">
                                <div id="krqxchartZxt" class="zxtys"></div>
                            </div>
                        </el-row>
                        <Jskr :lsDialog="lsDialog"></Jskr>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import pageFooter from "@/components/pageFooter";
import tabSwitch from "@/components/buttonGather/tabSwitch";
import { fileHost } from "@/utils/config";
import Jskr from './jskr.vue';
export default {
    name: "rsvrOpen",
    components: {
        pageFooter,
        tabSwitch,
        Jskr
    },
    props:{
        rsvrCz:{
            type:Object
        },
    },
    data() {
        return {
            abc:true,
            fileHost:fileHost,
            loading:false,
            kloading:false,
            csTime:[],
            buttonNamesArr:['水位过程','基本信息','库容曲线'],
            czOptions:[],
            delImg: false,
            activeName: 0,
            sstj:{
                sjd:'监测',
            },
            // 查询表单
            orForm: {
                size: 20,
                current: 1,
                total: 0,
                czOrbh:"",
                hour:0,
            },
            sjdOptions: [
                {
                    value: 0,
                    label: '监测'
                }, {
                    value: 1,
                    label: '一小时'
                }, {
                    value: 3,
                    label: '三小时'
                }, {
                    value: 6,
                    label: '六小时'
                }, {
                    value: 12,
                    label: '十二小时'
                }, {
                    value: 24,
                    label: '二十四小时'
                }
            ],
            jcTime:[],
            otableData:[],
            ozxtndData:[],
            ozxtData:[],
            ozxtDataX:[],
            ozxtDataY1:[],
            ozxtDataY2:[],
            ozxtDataX3:[],
            ozxtDataY3:[],

            okrData:[],
            okrDataX:[],
            okrDataY:[],
            jbxx:{},
            skjbxx1:{},
            skjbxx2:{},
            lsDialog: {
                title: "",
                lsFormVisible: false,
                lsJsFormVisible: false,
                data: {},
            },
        };
    },
    methods:{
        getCzListByCzLb() {
            this.request.post('/rm-bstbprp/v1/listByMstp', ['0607','0613']).then(res => {
                if (res.ok) {
                    this.czOptions = res.data;
                    this.jygcData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        curTabButtonClickDeal(val){
            this.activeName = val;
            if (val == 0) {
                this.jygcData();
            } else if (val == 1) {
                this.jbxxData();
            } else {
                this.krqxData();
            }
        },
        xgDate(dateStr){
            dateStr = dateStr.substring(0,19);
            dateStr = dateStr.replace(/-/g,'/');
            var timeTamp = new Date(dateStr).getTime();
            return timeTamp;
        },
        delImgDeal(){
            this.rsvrCz.openShow = false;
            this.orForm.hour = 0;
            this.activeName = 0;
        },
        cshData(){
            this.abc = this.rsvrCz.cz.mstp.indexOf('0607')>=0;
            this.csTime = this.rsvrCz.sjfw;
            this.getCzListByCzLb();
        },
        jygcData(){
            let ccc;
            for (let i = 0; i < this.czOptions.length; i++) {
                if (this.czOptions[i].stcd == this.rsvrCz.cz.stcd) {
                    ccc = this.czOptions[i].mstp;
                }
            }
            this.abc = ccc.indexOf('0607')>=0;
            let qwer1 = this.xgDate(this.rsvrCz.sjfw[0].substr(0,13) + ':00:00');
            let qwer2 = this.xgDate(this.rsvrCz.sjfw[1].substr(0,13) + ':00:00');
            qwer1 = qwer1/(60*60*1000);
            qwer2 = qwer2/(60*60*1000);
            let qwer = qwer2 - qwer1;
            if (qwer > 8784) {
                this.$message.warning('查询时间不允许超过一年！');
                return;
            }


            if (this.jcTime.length < 1 || this.orForm.hour == 0) {
                this.jcTime = this.rsvrCz.sjfw;
            }
            this.delImg = this.rsvrCz.openShow;
            this.zxtData();
            this.bgData();
        },
        sjChange(){
            this.jcTime = this.rsvrCz.sjfw;
        },
        sjdChange(val){
            // this.$set(this.orForm,'hour',val)
            if (val == 0) {
                this.rsvrCz.sjfw = this.jcTime;
            } else if (val == 1) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime = this.xgDate(this.jcTime[1] + ':00');
                if (hqTime%(60*60*1000) == 0) {
                    hqTime = new Date(hqTime);
                } else {
                    hqTime = new Date(hqTime + 1 * 60 * 60 * 1000);
                }
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                this.rsvrCz.sjfw = aaTime;
            } else if (val == 3) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%3 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 3 - ((hqTime1 - hqTime0)/(60*60*1000))%3;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%3 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 3 - ((hqTime1 - hqTime0)/(60*60*1000))%3;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                }
            } else if (val == 6) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%6 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 6 - ((hqTime1 - hqTime0)/(60*60*1000))%6;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%6 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 6 - ((hqTime1 - hqTime0)/(60*60*1000))%6;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                }
            } else if (val == 12) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%12 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 12 - ((hqTime1 - hqTime0)/(60*60*1000))%12;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%12 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 12 - ((hqTime1 - hqTime0)/(60*60*1000))%12;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                }
            } else if (val == 24) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%24 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 24 - ((hqTime1 - hqTime0)/(60*60*1000))%24;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%24 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 24 - ((hqTime1 - hqTime0)/(60*60*1000))%24;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.rsvrCz.sjfw = aaTime;
                }
            }
            this.jygcData();
        },

        frontOneHour (fmt,hqTime) {
            var currentTime = hqTime;
            var o = {
                'M+': currentTime.getMonth() + 1, // 月份
                'd+': currentTime.getDate(), // 日
                'h+': currentTime.getHours(), // 小时
                'm+': currentTime.getMinutes(), // 分
                's+': currentTime.getSeconds(), // 秒
                'q+': Math.floor((currentTime.getMonth() + 3) / 3), // 季度
                'S': currentTime.getMilliseconds() // 毫秒
            }
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentTime.getFullYear() + '').substr(4 - RegExp.$1.length))
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
            return fmt
        },

        zxtData(){
            this.loading = true;
            if (this.orForm.hour == 0) {
                let htGE = this.rsvrCz.sjfw[0] + ':00';
                let htLE = this.rsvrCz.sjfw[1] + ':00';
                let a = {
                    ...this.orForm,
                    stcd:this.rsvrCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get("/rm-mrsvr/v1/rsvr-pro/list",{params:a}).then((res) => {
                    if(res.ok){
                        this.ozxtndData = res.data;
                        this.ozxtData = res.data.rsvrProVOList;
                        let _this = this;
                        this.ozxtDataX = [];
                        this.ozxtDataY1 = [];
                        this.ozxtDataY2 = [];
                        this.ozxtData.forEach(function(value,index,obj) {
                            _this.ozxtDataX.push(value.tm);
                            _this.ozxtDataY1.push(value.z);
                            _this.ozxtDataY2.push(value.w);
                        })
                        this.$nextTick(()=>{
                            //元素加载完成后执行的代码
                            this.initssChar();
                        });
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            } else {
                let htGE = this.rsvrCz.sjfw[0].substr(0,13);
                let htLE = this.rsvrCz.sjfw[1].substr(0,13);
                let a = {
                    ...this.orForm,
                    stcd:this.rsvrCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get("/rm-mrsvr/v1/rsvr-pro/hour/list",{params:a}).then((res) => {
                    if(res.ok){
                        this.ozxtndData = res.data;
                        this.ozxtData = res.data.rsvrProVOList;
                        let _this = this;
                        this.ozxtDataX = [];
                        this.ozxtDataY1 = [];
                        this.ozxtDataY2 = [];
                        this.ozxtData.forEach(function(value,index,obj) {
                            _this.ozxtDataX.push(value.ht);
                            _this.ozxtDataY1.push(value.z);
                            _this.ozxtDataY2.push(value.w);
                        })

                        let jylData = res.data.hrainVOList;
                        this.ozxtDataX3 = [];
                        this.ozxtDataY3 = [];
                        if (jylData) {
                            jylData.forEach(function(value,index,obj) {
                                _this.ozxtDataX3.push(value.ht);
                                _this.ozxtDataY3.push(value.dhp);
                            })
                        }

                        this.$nextTick(()=>{
                            //元素加载完成后执行的代码
                            this.initssChar();
                            this.initjylChar();
                        });
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            }
            
        },
        hyhy(){
            this.initssChar();
        },
        //折线图绘制
        initssChar(){
            let _that = this;
            let ztcd;
            if (this.orForm.hour == 0) {
                ztcd = 16;
            } else if (this.orForm.hour == 1) {
                ztcd = 16;
            } else if (this.orForm.hour == 3) {
                ztcd = 16;
            } else if (this.orForm.hour == 6) {
                ztcd = 16;
            } else if (this.orForm.hour == 12) {
                ztcd = 10;
            } else if (this.orForm.hour == 24) {
                ztcd = 10;
            }


            let zxtCharts = this.$echarts.init(document.getElementById("chartZxt"));
            let option1
            if (this.abc) {
                option1 = {
                    color: ['#2c83ea','#24bd8a'],
                    tooltip: {
                        //鼠标悬停提示内容
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                        },
                        formatter:function(params){
                            // return '时间：'+params[0].name+'<br/>'+
                            //         '水位(m)：'+params[0].value+'<br/>'+
                            //         '蓄水量(10⁴m³)：'+params[1].value+'<br/>'+
                            //         '设计水位(m)：'+_that.ozxtndData.sjhsw+'<br/>'+
                            //         '汛限水位(m)：'+_that.ozxtndData.fhxzsw;

                            var htmlStr = '';
                            for(var i=0;i<params.length;i++){
                                var param = params[i];
                                var xName = param.name;//x轴的名称
                                var seriesName = param.seriesName;//图例名称
                                var value = param.value;//y轴值
                                var color = param.color;//图例颜色
                                
                                if(i===0){
                                htmlStr += xName + '<br/>';//x轴的名称
                                }
                                htmlStr +='<div>';
                                //为了保证和原来的效果一样，这里自己实现了一个点的效果
                                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
                    
                                // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                                //htmlStr += '<span style="color:'+color+'">';
                                
                                //圆点后面显示的文本
                                htmlStr += seriesName + '：' + (value ? value :'-');
                    
                                // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                                //htmlStr += '</span>';
                                
                                htmlStr += '</div>';
                            }
                            if (_that.ozxtndData.sjhsw) {
                                htmlStr += '<div style="color:#ea3323">设计水位(m)：'+ _that.ozxtndData.sjhsw +'</div>'
                            }
                            if (_that.ozxtndData.fhxzsw) {
                                htmlStr += '<div style="color:#fa9001">汛限水位(m)：'+ _that.ozxtndData.fhxzsw +'</div>'
                            }
                            return htmlStr;
                        }
                    },
                    toolbox: {
                        right: 10,
                        feature: {
                            dataZoom: {
                                show: this.orForm.hour == 0 ? true : false,
                                iconStyle:{ //不需要图标可以设置隐藏按钮
                                    opacity:0
                                },
                                yAxisIndex: 'none'
                            }
                        }
                    },
                    grid: {
                        left: '8%',
                        right: '8%',
                        bottom: '8%',
                        top: '11%',
                    },
                    legend: {
                        data: ['水位(m)', '蓄水量(10⁴m³)']
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,//x轴两边不留空白
                        data: this.ozxtDataX,
                        axisLabel:{  
                            formatter : function(params){
                                return _that.controlShowLength(params, ztcd);
                            }
                        },
                        // axisTick: {
                        //     show: false  // 是否显示刻度线
                        // }
                    },
                    yAxis: [
                        {
                            type: 'value',
                            name: '水位(m)',
                            scale:true,
                            max: function (value) {
                                let maxZ;
                                if (_that.ozxtndData.sjhsw) {
                                    maxZ = (parseFloat(_that.ozxtndData.sjhsw) + (0.01 * parseFloat(_that.ozxtndData.sjhsw))).toFixed(0);
                                } else {
                                    maxZ = (parseFloat(_that.ozxtndData.maxZ) + (0.01 * parseFloat(_that.ozxtndData.maxZ))).toFixed(0);
                                }
                                
                                if (parseFloat(_that.ozxtndData.maxZ)>parseFloat(_that.ozxtndData.sjhsw)) {
                                    maxZ = (parseFloat(_that.ozxtndData.maxZ) + (0.01 * parseFloat(_that.ozxtndData.maxZ))).toFixed(0);
                                }
                                let cc = parseFloat(maxZ) + parseFloat(10 - maxZ%10);
                                return cc;
                            },
                            min: function (value) {
                                let minZ;
                                if (_that.ozxtndData.fhxzsw) {
                                    minZ = (parseFloat(_that.ozxtndData.fhxzsw) - (0.01 * parseFloat(_that.ozxtndData.fhxzsw))).toFixed(0);
                                } else {
                                    minZ = (parseFloat(_that.ozxtndData.minZ) - (0.01 * parseFloat(_that.ozxtndData.minZ))).toFixed(0);
                                }
                                
                                if (parseFloat(_that.ozxtndData.minZ)<parseFloat(_that.ozxtndData.fhxzsw)) {
                                    minZ = (parseFloat(_that.ozxtndData.minZ) - (0.01 * parseFloat(_that.ozxtndData.minZ))).toFixed(0);
                                }
                                let cc = parseFloat(minZ) + parseFloat(10 - minZ%10);
                                return cc;
                            },
                            autoScale: false, // 关闭自动调整
                            alignTicks: true,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#2c83ea',
                                },
                            },
                            axisLabel: {
                                formatter: function(value) {
                                    return parseFloat(value).toFixed(0);
                                },
                            },
                        },
                        {
                            type: 'value',
                            name: '蓄水量(10⁴m³)',
                            autoScale: false, // 关闭自动调整
                            alignTicks: true,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#79CDCD',
                                },
                            },
                            axisLabel: {
                                formatter: function(value) {
                                    return parseFloat(value).toFixed(0);
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: '水位(m)',
                            data: this.ozxtDataY1,
                            yAxisIndex: 0,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: {
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0.1,
                                            color: 'rgba(44, 131, 234, 0.7) ' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.9,
                                            color: 'rgba(44, 131, 234, 0.1)' // 100% 处的颜色
                                        }
                                    ]
                                }
                            },
                            markLine: {
                                symbol: ['none'], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                                label:{
                                    position:"start" //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                                },
                                data : [
                                    {
                                        silent:true,
                                        lineStyle:{
                                            type:"dashed",
                                            color:"#ea3323",
                                            width: 2
                                        },
                                        yAxis: this.ozxtndData.sjhsw ? this.ozxtndData.sjhsw : '-',
                                        label: {
                                            normal: {
                                                formatter: '设计水位',
                                                color: '#ea3323',
                                            },
                                        }
                                    },
                                    {
                                        silent:true,
                                        lineStyle:{
                                            type:"dashed",
                                            color:"#fa9001",
                                            width: 2
                                        },
                                        yAxis: this.ozxtndData.fhxzsw ? this.ozxtndData.fhxzsw : '-',
                                        label: {
                                            normal: {
                                                formatter: '汛限水位',
                                                color: '#fa9001',
                                            }
                                        }
                                    },
                                ]
                            }
                        },
                        {
                            name: '蓄水量(10⁴m³)',
                            data: this.ozxtDataY2,
                            yAxisIndex: 1,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: {
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0.1,
                                            color: 'rgba(151, 249, 207, 0.7) ' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.9,
                                            color: 'rgba(151, 249, 207, 0.1)' // 100% 处的颜色
                                        }
                                    ]
                                }
                            }
                        },
                    ]
                };
            } else {
                option1 = {
                    color: ['#2c83ea'],
                    tooltip: {
                        //鼠标悬停提示内容
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                        },
                        formatter:function(params){
                            // return '时间：'+params[0].name+'<br/>'+
                            //         '水位(m)：'+params[0].value+'<br/>'+
                            //         '蓄水量(10⁴m³)：'+params[1].value+'<br/>'+
                            //         '设计水位(m)：'+_that.ozxtndData.sjhsw+'<br/>'+
                            //         '汛限水位(m)：'+_that.ozxtndData.fhxzsw;

                            var htmlStr = '';
                            for(var i=0;i<params.length;i++){
                                var param = params[i];
                                var xName = param.name;//x轴的名称
                                var seriesName = param.seriesName;//图例名称
                                var value = param.value;//y轴值
                                var color = param.color;//图例颜色
                                
                                if(i===0){
                                htmlStr += xName + '<br/>';//x轴的名称
                                }
                                htmlStr +='<div>';
                                //为了保证和原来的效果一样，这里自己实现了一个点的效果
                                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
                    
                                // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                                //htmlStr += '<span style="color:'+color+'">';
                                
                                //圆点后面显示的文本
                                htmlStr += seriesName + '：' + (value ? value :'-');
                    
                                // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                                //htmlStr += '</span>';
                                
                                htmlStr += '</div>';
                            }
                            if (_that.ozxtndData.sjhsw) {
                                htmlStr += '<div style="color:#ea3323">设计水位(m)：'+ _that.ozxtndData.sjhsw +'</div>'
                            }
                            if (_that.ozxtndData.fhxzsw) {
                                htmlStr += '<div style="color:#fa9001">汛限水位(m)：'+ _that.ozxtndData.fhxzsw +'</div>'
                            }
                            return htmlStr;
                        }
                    },
                    toolbox: {
                        right: 10,
                        feature: {
                            dataZoom: {
                                show: this.orForm.hour == 0 ? true : false,
                                iconStyle:{ //不需要图标可以设置隐藏按钮
                                    opacity:0
                                },
                                yAxisIndex: 'none'
                            }
                        }
                    },
                    grid: {
                        left: '8%',
                        right: '8%',
                        bottom: '8%',
                        top: '11%',
                    },
                    legend: {
                        data: ['水位(m)']
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,//x轴两边不留空白
                        data: this.ozxtDataX,
                        axisLabel:{  
                            formatter : function(params){
                                return _that.controlShowLength(params, ztcd);
                            }
                        },
                    },
                    yAxis: [
                        {
                            type: 'value',
                            name: '水位(m)',
                            alignTicks: true,
                            scale:true,
                            max: function (value) {
                                let maxZ;
                                if (_that.ozxtndData.sjhsw) {
                                    maxZ = (parseFloat(_that.ozxtndData.sjhsw) + (0.01 * parseFloat(_that.ozxtndData.sjhsw))).toFixed(0);
                                } else {
                                    maxZ = (parseFloat(_that.ozxtndData.maxZ) + (0.01 * parseFloat(_that.ozxtndData.maxZ))).toFixed(0);
                                }
                                
                                if (parseFloat(_that.ozxtndData.maxZ)>parseFloat(_that.ozxtndData.sjhsw)) {
                                    maxZ = (parseFloat(_that.ozxtndData.maxZ) + (0.01 * parseFloat(_that.ozxtndData.maxZ))).toFixed(0);
                                }
                                let cc = parseFloat(maxZ) + parseFloat(10 - maxZ%10);
                                return cc;
                            },
                            min: function (value) {
                                let minZ;
                                if (_that.ozxtndData.fhxzsw) {
                                    minZ = (parseFloat(_that.ozxtndData.fhxzsw) - (0.01 * parseFloat(_that.ozxtndData.fhxzsw))).toFixed(0);
                                } else {
                                    minZ = (parseFloat(_that.ozxtndData.minZ) - (0.01 * parseFloat(_that.ozxtndData.minZ))).toFixed(0);
                                }
                                
                                if (parseFloat(_that.ozxtndData.minZ)<parseFloat(_that.ozxtndData.fhxzsw)) {
                                    minZ = (parseFloat(_that.ozxtndData.minZ) - (0.01 * parseFloat(_that.ozxtndData.minZ))).toFixed(0);
                                }
                                let cc = parseFloat(minZ) + parseFloat(10 - minZ%10);
                                return cc;
                            },
                            autoScale: false, // 关闭自动调整
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#2c83ea',
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: '水位(m)',
                            data: this.ozxtDataY1,
                            yAxisIndex: 0,
                            type: 'line',
                            // smooth: true,
                            areaStyle: {
                                color: {
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0.1,
                                            color: 'rgba(44, 131, 234, 0.7) ' // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.9,
                                            color: 'rgba(44, 131, 234, 0.1)' // 100% 处的颜色
                                        }
                                    ]
                                }
                            },
                            markLine: {
                                symbol: ['none'], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                                label:{
                                    position:"start" //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                                },
                                data : [
                                    {
                                        silent:true,
                                        lineStyle:{
                                            type:"dashed",
                                            color:"#ea3323",
                                            width: 2
                                        },
                                        yAxis: this.ozxtndData.sjhsw ? this.ozxtndData.sjhsw : '-',
                                        label: {
                                            normal: {
                                                formatter: '设计水位',
                                                color: '#ea3323',
                                            },
                                        }
                                    },
                                    {
                                        silent:true,
                                        lineStyle:{
                                            type:"dashed",
                                            color:"#fa9001",
                                            width: 2
                                        },
                                        yAxis: this.ozxtndData.fhxzsw ? this.ozxtndData.fhxzsw : '-',
                                        label: {
                                            normal: {
                                                formatter: '汛限水位',
                                                color: '#fa9001',
                                            }
                                        }
                                    },
                                ]
                            }
                        },
                    ]
                };
            }
            
            zxtCharts.setOption(option1,true);
            zxtCharts.resize();
            window.addEventListener("resize", function () {
                zxtCharts.resize();
            });
            this.loading = false;
            //开启默认选中区域缩放
            zxtCharts.dispatchAction({
                type:'takeGlobalCursor',
                key:'dataZoomSelect',
                dataZoomSelectActive:true
            })
        },
        controlShowLength(params, length){
            if (length != null) {
                if (length == 16) {
                    params = params.substring(0, 13) + ':00';
                } else {
                    params = params.substring(0, length);
                }
            }
            var newParamsName = "";
            // var paramsNameNumber = params.length;
            // var provideNumber = 4;
            // var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
            // if (paramsNameNumber > provideNumber) {
            //     for (var p = 0; p < rowNumber; p++) {
            //         var tempStr = "";
            //         var start = p * provideNumber;
            //         var end = start + provideNumber;
            //         if (p == rowNumber - 1) {
            //             tempStr = params.substring(start, paramsNameNumber);
            //         } else {
            //             tempStr = params.substring(start, end) + "\n";
            //         }
            //     newParamsName += tempStr;
            //     }
            // } else {
            //     newParamsName = params;
            // }
            newParamsName = params;
            return newParamsName
        },
        initjylChar(){
            let _that = this;
            let ztcd;
            if (this.orForm.hour == 0) {
                ztcd = 16;
            } else if (this.orForm.hour == 1) {
                ztcd = 16;
            } else if (this.orForm.hour == 3) {
                ztcd = 16;
            } else if (this.orForm.hour == 6) {
                ztcd = 16;
            } else if (this.orForm.hour == 12) {
                ztcd = 10;
            } else if (this.orForm.hour == 24) {
                ztcd = 10;
            }
            let jyzxtCharts = this.$echarts.init(document.getElementById("jychartZxt"));
            jyzxtCharts.clear();
            let option = {
                color: ['#2c83ea'],
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                },
                grid: {
                    left: '8%',
                    right: '8%',
                    bottom: '15%',
                    top: '8%',
                },
                // legend: {
                //     data: ['降雨量(mm)']
                // },
                xAxis: {
                    data: this.ozxtDataX3,
                    type: 'category',
                    boundaryGap: false,//x轴两边不留空白
                    position: 'top',
                    axisLabel:{
                        formatter : function(params){
                            return _that.controlShowLength(params, ztcd);
                        }
                    },
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '降雨量(mm)',
                        inverse: true,
                        alignTicks: true,
                        axisLine: {
                            show: true,
                        },
                    },
                ],
                series: [
                    {
                        name: '降雨量(mm)',
                        type: 'bar',
                        data: this.ozxtDataY3,
                        barWidth: 8, // 柱状图的宽度
                        itemStyle: {
                            color: '#0675e9',
                        }
                    },
                ]
            };
            jyzxtCharts.setOption(option,true);
            window.addEventListener("resize", function () {
                jyzxtCharts.resize();
            });
        },
        bgData(){
            if (this.orForm.hour == 0) {
                let htGE = this.rsvrCz.sjfw[0] + ':00';
                let htLE = this.rsvrCz.sjfw[1] + ':00';
                let a = {
                    ...this.orForm,
                    stcd:this.rsvrCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get("/rm-mrsvr/v1/rsvr-pro/pageList",{params:a}).then((res) => {
                    if(res.ok){
                        this.otableData = res.data.records;
                        this.orForm.total = res.data.total;
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            } else {
                let htGE = this.rsvrCz.sjfw[0].substr(0,13);
                let htLE = this.rsvrCz.sjfw[1].substr(0,13);
                let a = {
                    ...this.orForm,
                    stcd:this.rsvrCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get("/rm-mrsvr/v1/rsvr-pro/hour/pageList",{params:a}).then((res) => {
                    if(res.ok){
                        this.otableData = res.data.records;
                        this.orForm.total = res.data.total;
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            }
        },
        oreset() {
            this.orForm.hour = 0;
            // this.sjdChange(0);
            this.rsvrCz.sjfw = this.csTime;
            this.jygcData();
        },
        // 切换分页
        ocurrentChange(val) {
            this.orForm.current = val;
            this.bgData();
        },
        // 显示最大条数变动
        osizeChange(val) {
            this.orForm.size = val;
            this.bgData();
        },
        exportJygc(){
            if (this.orForm.hour == 0) {
                let htGE = this.rsvrCz.sjfw[0].substr(0,13) + ':00:00';
                let htLE = this.rsvrCz.sjfw[1].substr(0,13) + ':00:00';
                let b = {
                    ...this.orForm,
                    stcd:this.rsvrCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get('/rm-mrsvr/v1/rsvr-pro/export',{ params: b,responseType: "blob" }).then((res) => {
                    try {
                        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        // 这里填保存成的文件名
                        a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                        a.click();
                        URL.revokeObjectURL(a.href);
                        return;
                    } catch (error) {
                        const reader = new FileReader(); 
                        reader.readAsText(res.data, 'utf-8');
                        let _this = this;
                        reader.onload=function(){
                            const msg = JSON.parse(reader.result);
                            if (!msg.ok) {
                                if (msg.error.code == 3001) {
                                    _this.$message.error(msg.error.message);
                                } else {
                                    _this.$message.warning(msg.error.message);
                                }
                            }
                        }
                    }
                });
            } else {
                let htGE = this.rsvrCz.sjfw[0];
                let htLE = this.rsvrCz.sjfw[1];
                let b = {
                    ...this.orForm,
                    stcd:this.rsvrCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get('/rm-mrsvr/v1/rsvr-pro/hour/export',{ params: b,responseType: "blob" }).then((res) => {
                    try {
                        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        // 这里填保存成的文件名
                        a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                        a.click();
                        URL.revokeObjectURL(a.href);
                        return;
                    } catch (error) {
                        const reader = new FileReader(); 
                        reader.readAsText(res.data, 'utf-8');
                        let _this = this;
                        reader.onload=function(){
                            const msg = JSON.parse(reader.result);
                            if (!msg.ok) {
                                if (msg.error.code == 3001) {
                                    _this.$message.error(msg.error.message);
                                } else {
                                    _this.$message.warning(msg.error.message);
                                }
                            }
                        }
                    }
                });
            }
        },

        krqxData(){
            this.kloading = true;
            this.request.get("/rm-bzvarl/v1").then((res) => {
                if(res.ok){
                    this.okrData = res.data;
                    let _this = this;
                    this.okrDataX = [];
                    this.okrDataY = [];
                    this.okrData.forEach(function(value,index,obj) {
                        _this.okrDataX.push(value.w);
                        _this.okrDataY.push(value.rz);
                    })
                    this.$nextTick(()=>{
                        //元素加载完成后执行的代码
                        this.initkrqxChar();
                    });
                }else{
                    this.$message.error(res.error.message)
                }
            });
        },
        //折线图绘制
        initkrqxChar(){
            let krqxzxtCharts = this.$echarts.init(document.getElementById("krqxchartZxt"));
            let option = {
                color: ['#4aa4fa'],
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                    formatter:function(params){
                        // return '时间：'+params[0].name+'<br/>'+
                        //         '水位(m)：'+params[0].value+'<br/>'+
                        //         '蓄水量(10⁴m³)：'+params[1].value+'<br/>'+
                        //         '设计水位(m)：'+_that.ozxtndData.sjhsw+'<br/>'+
                        //         '汛限水位(m)：'+_that.ozxtndData.fhxzsw;

                        var htmlStr = '';
                        for(var i=0;i<params.length;i++){
                            var param = params[i];
                            var xName = '库容(10⁴m³)：' + param.name;//x轴的名称
                            var seriesName = param.seriesName;//图例名称
                            var value = param.value;//y轴值
                            var color = param.color;//图例颜色
                            
                            if(i===0){
                                htmlStr += xName + '<br/>';//x轴的名称
                            }
                            htmlStr +='<div>';
                            //为了保证和原来的效果一样，这里自己实现了一个点的效果
                            // htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
                            //圆点后面显示的文本
                            htmlStr += seriesName + '：' + (value ? value :'-');
                            htmlStr += '</div>';
                        }
                        return htmlStr;
                    }
                },
                // legend: {
                //     data: ['水位','库容']
                // },
                xAxis: {
                    type: 'category',
                    name: '库容(10⁴m³)',
                    boundaryGap: false,//x轴两边不留空白
                    data: this.okrDataX,
                    axisTick: {
                        show: false  // 是否显示刻度线
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '水位(m)',
                        scale:true,
                    },
                ],
                series: [
                    {
                        name: '水位(m)',
                        data: this.okrDataY,
                        type: 'line',
                        // smooth: true,
                        areaStyle: {
                            color: {
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgba(175, 214, 251, 0.7) ' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.9,
                                        color: 'rgba(175, 214, 251, 0.1)' // 100% 处的颜色
                                    }
                                ]
                            }
                        }
                    }
                ]
            };
            krqxzxtCharts.setOption(option,true);
            krqxzxtCharts.resize();
            window.addEventListener("resize", function () {
                krqxzxtCharts.resize();
            });
            this.kloading = false;
        },

        jbxxData(){
            this.request.get("/rm-bstbprp/v1/getInfoByStcd/"+this.rsvrCz.cz.stcd).then((res) => {
                if(res.ok){
                    this.jbxx = res.data;
                }else{
                    this.$message.error(res.error.message)
                }
            });
            this.request.get("/rm-bres/queryRes").then((res) => {
                if(res.ok){
                    this.skjbxx1 = res.data;
                }else{
                    this.$message.error(res.error.message)
                }
            });
            this.request.get("/rm-bresgcxx/v1/getGcxx").then((res) => {
                if(res.ok){
                    this.skjbxx2 = res.data;
                }else{
                    this.$message.error(res.error.message)
                }
            });
        },
        jsjs(){
            this.lsDialog.title = '根据水位计算库容';
            // this.lsDialog.data = {...this.lsData};
            this.lsDialog.lsJsFormVisible = true;
        },
    },
}
</script>

<style scoped>
::v-deep .el-dialog{
    margin-bottom:0;
    width: 100%; 
    height: calc(100% - 110px);
}
/*去除头部*/
::v-deep .el-dialog__header{
    display: none;
}
/*去除尾部*/
::v-deep .el-dialog__footer{
    display: none;
}
::v-deep .el-dialog__body{
    height: 100%;
    padding: 0px;
}
.zxtys{
    height: 100%;
    width: 100%;
}

/* 按钮样式 */
.queryButton {
    font-family: PingFang SC;
    font-size: 1.4rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    border-radius: 0.5rem;
    margin-left: 1.5rem;
}
.czBut {
    background-color: #a8a8a8;
    border: solid 0rem #f4f4f4;
}
.queryButtonPadding {
    padding-left: 2rem;
    padding-right: 2rem;
}
.qDcImg {
    width: 1.2rem;
    height: 1.2rem;
}
.qDcBtn {
    position: absolute;
    right: 4rem;
}
</style>
